/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentPeoplePersonidCourses200,
  GetApiV1IndividualpaymentPeoplePersonidCourses401,
  GetApiV1IndividualpaymentPeoplePersonidCourses500,
  GetApiV1IndividualpaymentPeoplePersonidCoursesPathParams,
  GetApiV1IndividualpaymentPeoplePersonidCoursesQueryParams,
  GetApiV1IndividualpaymentPeoplePersonidCoursesQueryResponse,
} from "../../types/individualPaymentController/GetApiV1IndividualpaymentPeoplePersonidCourses.ts";
import { individualPaymentPersonCourseViewModelSchema } from "../individualPaymentPersonCourseViewModelSchema.ts";

export const getApiV1IndividualpaymentPeoplePersonidCoursesPathParamsSchema =
  z.object({
    personId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1IndividualpaymentPeoplePersonidCoursesPathParams>;

export const getApiV1IndividualpaymentPeoplePersonidCoursesQueryParamsSchema = z
  .object({
    OurNumber: z.optional(z.string()),
    InvoiceNumber: z.optional(z.string()),
    ThirdPartyCpf: z.optional(z.string()),
    ThirdPartyCnpj: z.optional(z.string()),
  })
  .optional() as unknown as ToZod<GetApiV1IndividualpaymentPeoplePersonidCoursesQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentPeoplePersonidCourses200Schema = z.array(
  z.lazy(() => individualPaymentPersonCourseViewModelSchema),
) as unknown as ToZod<GetApiV1IndividualpaymentPeoplePersonidCourses200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentPeoplePersonidCourses401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentPeoplePersonidCourses401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentPeoplePersonidCourses500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentPeoplePersonidCourses500>;

export const getApiV1IndividualpaymentPeoplePersonidCoursesQueryResponseSchema =
  z.lazy(
    () => getApiV1IndividualpaymentPeoplePersonidCourses200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentPeoplePersonidCoursesQueryResponse>;
